import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { LOCAL__ui_drag_and_drop_set_image_dragged } from '@/state/ui/drag_and_drop/LOCAL__ui_drag_and_drop_set_image_dragged';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DragEvent } from 'react';

export function HOOK__image_drag(image_asset: DTO__image_asset) {
  const dispatch = use_dispatch();

  function onDragStart(e: DragEvent<HTMLImageElement>) {
    if (image_asset.is_stub()) return;

    dispatch(LOCAL__ui_set_boolean({ key: 'drag_and_drop__image_internal_zones_show', value: true }));
    dispatch(LOCAL__ui_drag_and_drop_set_image_dragged(image_asset));
  }

  function onDragEnd() {
    if (image_asset.is_stub()) return;

    dispatch(LOCAL__ui_set_boolean({ key: 'drag_and_drop__image_internal_zones_show', value: false }));
    dispatch(LOCAL__ui_drag_and_drop_set_image_dragged());
  }

  return { onDragStart, onDragEnd };
}
